export { default, QuestionAnswer } from './faq';
